export const CodigosRegistrosGenericos = {
    GradosAcademicos: 'AcademicGrade',
    EstadosAcademicos: 'AcademicStates',
    ClasificadosAdmision: 'AdmissionClassification',
    TiposDirecciones: 'AddressType',
    Edificios: 'Buildings',
    pisosEdificio: 'BuildingFloors',
    ClasificadoCarrera: 'CareerClassfi',
    EstadosCivil: 'CivilStatus',
    TiposContactos: 'ContactType',
    ClasificadoCurso: 'CourseClassfi',    
    CursoCurricular: 'CurriculumCourse',
    tipoAulas: 'ClassroomType',
    TiposEmail: 'EmailType',
    ListaGeneros: 'Gender',
    RequisitosProgramasGraduacion: 'GraduationRequirements',
    Trabajos: 'Jobs',
    IdiomasNiveles: 'LanguageLevel',
    Idiomas: 'Languages',
    ModalidadProgramas: 'Modalities',
    TiposPeriodo: 'PeriodType',
    RequisitosProgramasAcademicos: 'ProgramRequirement',
    JornadasProgramas: 'ProgSchedules',
    TiposCursosCurriculum: 'TypeCurriculumCourse',
    LugaresTrabajo: 'Workplace',
    EstadosAdmision: 'AdmissionStates',
    TiposOfertaAcademica: 'TypeAcademicOffer',
    TiposRetiroCursos: 'ReasonDropCourse',
    TiposAnotacionesEstudiantes: 'StudentAnnotationType'
}
//se usa para llamados de ObtenerListadoRegistrosGenericos
export default CodigosRegistrosGenericos;